// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardd {
  border-radius: 12px;
  padding-bottom: 10px;
}

.heading {
  padding: 0.7rem 0.5rem;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  background-color: #52796F;
  color: white;
  font-weight: 500;
  font-size: 16px;
  font-family: "Roboto", "Helvetica Neue", Arial, Tahoma;
}

.heading2 {
  padding-bottom: 0;
  margin-top: 0;
  font-weight: 550;
  font-size: 16px;
  font-family: "Roboto", "Helvetica Neue", Arial, Tahoma;
}

.heading3 {
  margin-bottom: 0;
  margin-top: 0;
  padding-left: 20px;
  font-weight: 500;
  font-size: 16px;
  font-family: "Roboto", "Helvetica Neue", Arial, Tahoma;
}

.heading4 {
  font-weight: 500;
  font-size: 13.5px;
  font-family: "Roboto", "Helvetica Neue", Arial, Tahoma;
}

.infodiv {
  padding-left: 20px;
}

.info {
  padding: 0.2rem 1rem;
  text-align: justify;
  font-size: 0.9rem;
}

.line {
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 0;
}

.linked {
  font-size: 0.9rem;
  font-weight: 500;
}

.list {
  padding-left: 50px;
  text-align: left;
}

.list2 {
  padding-left: 20px;
  text-align: left;
}

.db {
  margin-left: 10px;
  margin-right: 10px;
}

.db2 {
  padding-top: 25px;
  margin-left: 10px;
  margin-right: 10px;
}

.hpidb {
  padding-top: 15px;
  margin-left: 10px;
  margin-right: 10px;
}

.web {
  text-align: center;
  margin: 0;
}

.title {
  text-align: center;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 0;
  font-size: 1rem;
  font-weight: bold;
}

.ant-btn-primary {
  color: #fff;
  border-color: lightblue !important;
  background: #539de3;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}

.ant-btn-round {
  height: 32px;
  padding: 4px 16px;
  font-size: 14px;
  border-radius: 32px;
}

.btn-primary {
  background-color: rgb(190, 83, 83);
  border-color: rgb(190, 83, 83) !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/Home.scss","webpack://./src/scss/colors.scss"],"names":[],"mappings":"AAIA;EACI,mBAAA;EACA,oBAAA;AAHJ;;AAMA;EACI,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBCTQ;EDUR,YAAA;EACA,gBAAA;EACA,eAAA;EACA,sDAAA;AAHJ;;AAMA;EACI,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,sDAAA;AAHJ;;AAMA;EAEI,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,sDAAA;AAJJ;;AAOA;EAKI,gBAAA;EACA,iBAAA;EACA,sDAAA;AARJ;;AAWA;EACC,kBAAA;AARD;;AAWA;EACI,oBAAA;EACA,mBAAA;EACA,iBAAA;AARJ;;AAUA;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;AAPJ;;AAUA;EACI,iBAAA;EACA,gBAAA;AAPJ;;AAUA;EACI,kBAAA;EACA,gBAAA;AAPJ;;AAUA;EACI,kBAAA;EACA,gBAAA;AAPJ;;AAWA;EACG,iBAAA;EACA,kBAAA;AARH;;AAUA;EACI,iBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUC;EACG,iBAAA;EACA,iBAAA;EACA,kBAAA;AAPJ;;AAUC;EACI,kBAAA;EACA,SAAA;AAPL;;AAWA;EACI,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AARJ;;AAUC;EACG,WAAA;EACA,kCAAA;EACA,mBAAA;EACA,yCAAA;EACA,wCAAA;AAPJ;;AAUE;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAPJ;;AASE;EACE,kCAAA;EACA,yCAAA;AANJ","sourcesContent":["@import '../../scss/colors.scss';\n@import '../../scss/globals';\n\n\n.cardd{\n    border-radius: 12px;\n    padding-bottom: 10px;\n}\n\n.heading{\n    padding: 0.7rem 0.5rem;\n    border-top-left-radius: 12px;\n    border-top-right-radius: 12px;\n    background-color: $palette-2;\n    color:white;\n    font-weight: 500;\n    font-size: 16px;\n    font-family: \"Roboto\", \"Helvetica Neue\", Arial, Tahoma;\n}\n\n.heading2{\n    padding-bottom: 0;\n    margin-top: 0;\n    font-weight: 550;\n    font-size: 16px;\n    font-family: \"Roboto\", \"Helvetica Neue\", Arial, Tahoma;\n}\n\n.heading3{\n    // text-align: left;\n    margin-bottom: 0;\n    margin-top: 0;\n    padding-left: 20px;\n    font-weight: 500;\n    font-size: 16px;\n    font-family: \"Roboto\", \"Helvetica Neue\", Arial, Tahoma;\n}\n\n.heading4{\n    // text-align: left;\n    // margin-bottom: 0;\n    // margin-top: 0;\n    // padding-left: 20px;\n    font-weight: 500;\n    font-size: 13.5px;\n    font-family: \"Roboto\", \"Helvetica Neue\", Arial, Tahoma;\n}\n\n.infodiv{\n padding-left: 20px;   \n}\n\n.info{\n    padding: 0.2rem 1rem;\n    text-align: justify;\n    font-size: 0.9rem;\n}\n.line{\n    margin-left: 20px;\n    margin-right: 20px;\n    margin-bottom: 0;\n    \n}\n.linked{\n    font-size: 0.9rem;\n    font-weight: 500;\n}\n\n.list {\n    padding-left: 50px;\n    text-align: left;\n}\n\n.list2 {\n    padding-left: 20px;\n    text-align: left;\n}\n\n\n.db{\n   margin-left: 10px;\n   margin-right: 10px;\n}\n.db2{\n    padding-top: 25px;\n    margin-left: 10px;\n    margin-right: 10px;\n }\n\n .hpidb{\n    padding-top: 15px;\n    margin-left: 10px;\n    margin-right: 10px;\n }\n\n .web{\n     text-align: center;\n     margin:0;\n    \n }\n\n.title{\n    text-align:center ;\n    padding-left: 20px;\n    padding-right:20px;\n    padding-bottom: 0;\n    font-size:1rem;\n    font-weight:bold;\n}\n .ant-btn-primary {\n    color: #fff;\n    border-color: lightblue !important;\n    background: #539de3;\n    text-shadow: 0 -1px 0 rgba(0,0,0,.12);\n    box-shadow: 0 2px 0 rgba(0,0,0,.045);\n  }\n\n  .ant-btn-round {\n    height: 32px;\n    padding: 4px 16px;\n    font-size: 14px;\n    border-radius: 32px;\n  }\n  .btn-primary {\n    background-color: rgb(190, 83, 83);\n    border-color: rgb(190, 83, 83) !important;\n  }","$black: #011627;\n$white: #FDFFFC;\n$palette-1: #217ed5;\n// $palette-2: #074ba5;\n$palette-2: #52796F;\n$palette-3: #FF9F1C;\n$palette-4:rgba(239, 48, 48, 0.822);\n$palette-5: #748b80;\n// 5fa15a\n// eab271\n// 1d2d44d0\n$nav-outline: #eff;\n$nav-outline-hvr: rgba(#217ed5,.4);\n\n$text-ghost:rgb(0, 0, 0);\n$text-light: #717171;\n$text-main: #393939;\n$text-hard: #212121;\n\n$color-light-grey: #c9c9c9;\n\n$palette-1-v-light: #abeef0;\n\n$palette-1-bg: #e2fcfc;\n$palette-2-bg: #ffe4eb;\n\n$palette-1-light: #1890ff;\n$palette-2-light: #ffe9ee;\n\n$palette-1-dark: #1472ca;\n$palette-2-dark: #ab1236;\n$palette-3-dark: #bb781c;\n$palette-4-dark:rgba(243, 16, 16, 0.87);\n\n$chip-bg: #def5ff;\n$chip-font: #036778;\n\n$palette-1-pastel: #a9fafc;\n\n$nav-back : #96c4a0;\n// 9ecf7d\n// f08585\n// 7dce82\n// rgb(152, 171, 196)"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
